import GenericNotification from './GenericNotification';

export default GenericNotification;
